import { render, staticRenderFns } from "./YSPlayer.vue?vue&type=template&id=1f0dcab4"
import script from "./YSPlayer.vue?vue&type=script&lang=js"
export * from "./YSPlayer.vue?vue&type=script&lang=js"
import style0 from "./YSPlayer.vue?vue&type=style&index=0&id=1f0dcab4&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports